import React from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'

import {
  MESSAGE_TYPES
} from '../config/constants'

import truncateString from '../data/formatters/truncate_string'
import formatMessageTime from '../data/formatters/message_time'
import isMessageModerated from '../data/helpers/is_message_moderated'
import showModal from '../data/actions/show_modal'

// import UserProfilePopup from '../user_profile_popup'
import ProfileImage from '../profile_image'
import MessageItem from './message_item'
import ModeratedMessageItem from './moderated_message_item'

class MessagesBatch extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.openUserProfileModal = this.openUserProfileModal.bind(this)
    this.renderMessageBatch = this.renderMessageBatch.bind(this)
    this.renderMessageItem = this.renderMessageItem.bind(this)
  }

  openUserProfileModal (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.showModal({type: 'userProfile', props: {uid: this.props.chattingUser.get('uid')}})
  }

  renderMessageItem (side, message, index) {
    if (isMessageModerated(message)) {
      return (
        <ModeratedMessageItem
          key={message.get('key')}
          message={message}
          side={side}
          containerId={this.props.containerId}
          maxBubbleWidth={this.props.maxBubbleWidth}
          shouldShowTriangle={index === 0 ? true : false}
          onMessageItemHeightChange={this.props.onMessageItemHeightChange}
          isRichMessageContentEnabled={this.props.isRichMessageContentEnabled}/>
      )
    }
    else {
      return (
        <MessageItem
          key={message.get('key')}
          message={message}
          side={side}
          containerId={this.props.containerId}
          maxBubbleWidth={this.props.maxBubbleWidth}
          shouldShowTriangle={index === 0 ? true : false}
          onMessageItemHeightChange={this.props.onMessageItemHeightChange}
          isRichMessageContentEnabled={this.props.isRichMessageContentEnabled}/>
      )
    }
  }

  renderMessageBatch (side) {
    const messages = this.props.batch.get('messages') || fromJS([])

    if (messages && messages.size > 0) {
      return messages.map(this.renderMessageItem.bind(this, side))
    }
    else {
      return messages
    }
  }

  renderProfileImage (user) {
    const profileImage = user.get('profileImage')
    const uid = user.get('uid')

    if (uid && profileImage) {
      return (
        <div style={{cursor: 'pointer', width: 32, height: 32, borderSpacing: 0, verticalAlign: 'top'}} onClick={this.openUserProfileModal}>
          <ProfileImage image={profileImage} user={user.toJS()} hasIndicator={false} size={32} />
        </div>
      )
    }
    else {
      return <div><div style={{width: 32, height: 32, background: '#BABABA', borderRadius: '50%'}}/></div>
    }
  }

  renderUserNameDetail () {
    const shouldShowModal = (
      this.props.messageType === MESSAGE_TYPES.GROUP ||
      this.props.messageType === MESSAGE_TYPES.MODERATED_GROUP
    )

    const userName = truncateString(this.props.chattingUser.get('name'), 20)

    if (shouldShowModal) {
      return (
        <span style={{cursor: 'pointer'}} onClick={this.openUserProfileModal}>
          {userName}
        </span>
      )
    }
    else {
      return userName
    }
  }

  renderUserName () {
    return (
      <div className='message-batch-username'>
        {this.renderUserNameDetail()}
      </div>
    )
  }

  renderLastMessageTime () {
    const time = this.props.batch.get('lastMessageTime')

    return (
      <div className='message-batch-time'>
        {formatMessageTime(time)}
      </div>
    )
  }

  render () {
    if (this.props.currentUser.get('uid') === this.props.batch.get('from')) {
      return (
        <div className='message-batch right'>
          <div>
            {this.renderMessageBatch('receiver')}
            {this.renderLastMessageTime()}
          </div>
        </div>
      )
    }
    else {
      return (
        <div className='message-batch'>
          {this.renderProfileImage(this.props.chattingUser)}
          <div>
            {this.renderUserName()}
            {this.renderMessageBatch('sender')}
            {this.renderLastMessageTime()}
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    chattingUser: fromJS(state.getIn(['users', ownProps.batch.get('from')], {})),
    currentUser: state.get('currentUser', fromJS({}))
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const MessagesBatchContainer = connect(
  mapStateToProps, mapDispatchToProps
)(MessagesBatch)

export default MessagesBatchContainer




/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/messages_batch.js
 **/